export const UTIMap = {
    "public.item": ["*/*"],
    "public.movie": ["video/*"],
    "public.audio": ["audio/*"],
    "public.image": ["image/*"],
    "public.text": ["text/*"],
    "public.plain-text": [".txt", "text/plain"],
    "public.rtf": [".rtf", "text/rtf"],
    "public.html": [".html", ".htm", "text/html"],
    "public.xml": [".xml", "text/xml"],
    "public.css": [".css", "text/css"],
    "public.json": [".json", "application/json"],
    "public.yaml": [".yaml", ".yml", "application/yaml", "application/x-yaml"],
    "public.toml": [".toml", "application/toml"],
    "public.ini": [".ini", "text/ini"],
    "public.comma-separated-values-text": [".csv", "text/csv"],
    "public.c-source": [".c", "text/x-csrc"],
    "public.objective-c-source": [".m", "text/x-objcsrc"],
    "public.c-plus-plus-source": [".cpp", ".cc", ".cp", ".c++", ".cxx", "text/x-c++src"],
    "public.objective-c-plus-plus-source": [".mm", "text/x-objcppsrc"],
    "public.c-header": [".h", "text/x-chdr"],
    "public.c-plus-plus-header": [".hpp", ".hh", ".h++", ".hxx", "text/x-c++hdr"],
    "public.assembly-source": [".s", ".S", "text/x-asm"],
    "com.apple.rez-source": [".r", "text/x-rez"],
    "public.mig-source": [".defs", "text/x-mig"],
    "com.apple.symbol-export": [".exp", "text/x-export"],
    "com.netscape.javascript-source": [".js", ".mjs", ".cjs", "text/javascript", "application/javascript"],
    "public.shell-script": [".sh", ".command", ".bat", ".cmd", ".ps1", "text/x-shellscript"],
    "public.csh-script": [".csh", "text/x-csh"],
    "public.perl-script": [".pl", ".pm", "application/perl", "text/x-perl", "text/x-perl-script"],
    "public.python-script": [".py", ".pyc", "application/python", "text/x-python", "text/x-python-script"],
    "public.ruby-script": [".rb", "application/ruby", "text/ruby", "text/x-ruby-script"],
    "public.php-script": [".php", ".php3", ".php4", ".php5", ".phtml", "application/php", "text/php", "text/x-php-script"],
    "com.apple.applescript.text": [".applescript"],
    "com.apple.applescript.script": [".scpt"],
    "public.object-code": [".o"],
    "com.microsoft.windows-executable": [".exe", ".com", ".msi", "application/vnd.microsoft.portable-executable"],
    "com.microsoft.windows-dynamic-link-library": [".dll", ".ocx", "application/x-msdownload"],
    "com.sun.java-source": [".java", ".jav", "text/x-java-source"],
    "com.sun.java-class": [".class"],
    "com.sun.java-archive": [".jar", "application/java-archive"],
    "com.sun.java-properties": [".properties", "text/x-java-properties"],
    "com.sun.java-keystore": [".jks", "application/x-java-keystore"],
    "com.sun.java-web-start": [".jnlp", "application/jnlp"],
    "com.apple.quartz-composer-composition": [".qtz", "application/x-quartzcomposer"],
    "org.gnu.gnu-tar-archive": [".gtar", "application/x-gtar"],
    "public.tar-archive": [".tar", "application/x-tar", "application/tar"],
    "org.gnu.gnu-zip-archive": [".gz", ".gzip", "application/gzip", "application/x-gzip"],
    "org.gnu.gnu-zip-tar-archive": [".tgz", "application/x-tar-gz", "application/x-gzip-compressed-tar"],
    "public.bzip2-archive": [".bz2", "application/x-bzip2"],
    "public.tar-bzip2-archive": [".tbz", ".tbz2", "application/x-bzip2-compressed-tar"],
    "com.apple.xar-archive": [".xar", "application/x-xar"],
    "com.apple.binhex-archive": [".hqx", "application/mac-binhex40", "application/binhex"],
    "com.apple.macbinary-archive": [".bin", "application/x-macbinary", "application/macbinary"],
    "public.vcard": [".vcf", "text/vcard"],
    "public.jpeg": [".jpg", ".jpeg", "image/jpeg"],
    "public.jpeg-2000": [".jp2", "image/jp2"],
    "public.tiff": [".tiff", ".tif", "image/tiff"],
    "com.apple.pict": [".pct", "image/pict"],
    "com.apple.macpaint-image": [".pntg", "image/x-macpaint"],
    "public.png": [".png", "image/png"],
    "public.xbitmap-image": [".xbm", "image/x-xbitmap"],
    "com.apple.quicktime-image": [".qtif", "image/x-quicktime"],
    "com.apple.icns": [".icns", "image/icns"],
    "com.apple.quicktime-movie": [".mov", ".qt", "video/quicktime"],
    "public.avi": [".avi", "video/x-msvideo"],
    "public.mpeg": [".mpg", ".mpeg", "video/mpeg"],
    "public.mpeg-4": [".mp4", "video/mp4"],
    "public.3gpp": [".3gp", "video/3gpp"],
    "public.3gpp2": [".3g2", "video/3gpp2"],
    "public.mp3": [".mp3", "audio/mpeg", "audio/mp3"],
    "public.mpeg-4-audio": [".m4a", "audio/x-m4a"],
    "com.apple.protected-mpeg-4-audio": [".m4p", "audio/mp4", "audio/x-m4p"],
    "public.ulaw-audio": [".au", "audio/basic"],
    "public.aifc-audio": [".aifc", "audio/x-aifc"],
    "public.aiff-audio": [".aiff", ".aif", "audio/aiff"],
    "com.apple.coreaudio-format": [".caf", "audio/x-caf"],
    "com.apple.bundle": [".bundle"],
    "com.apple.application-bundle": [".app"],
    "com.apple.plugin": [".plugin"],
    "com.apple.metadata-importer": [".mdimporter"],
    "com.apple.dashboard-widget": [".wdgt"],
    "public.cpio-archive": [".cpio", "application/x-cpio"],
    "public.zip-archive": [".zip", "application/zip"],
    "com.apple.framework": [".framework"],
    "com.apple.rtfd": [".rtfd", "application/rtfd"],
    "public.opentype-font": [".otf", "application/x-font-opentype"],
    "public.truetype-ttf-font": [".ttf", "application/x-font-truetype"],
    "public.truetype-collection-font": [".ttc", "application/x-font-ttf"],
    "com.apple.font-suitcase": [".dfont", "application/x-font-suitcase"],
    "com.adobe.postscript.pfa-font": [".pfa", "application/x-font-type1"],
    "com.adobe.postscript-pfb-font": [".pfb", "application/x-font-type2"],
    "com.apple.colorsync-profile": [".icc", ".icm", "application/vnd.iccprofile"],
    "com.adobe.pdf": [".pdf", "application/pdf"],
    "com.adobe.postscript": [".ps", "application/postscript"],
    "com.adobe.encapsulated-postscript": [".eps", "application/x-eps"],
    "com.adobe.photoshop-image": [".psd", "image/vnd.adobe.photoshop", "image/psd"],
    "com.adobe.illustrator.ai-image": [".ai", "application/illustrator", "application/vnd.adobe.illustrator"],
    "com.compuserve.gif": [".gif", "image/gif"],
    "com.microsoft.bmp": [".bmp", "image/bmp"],
    "com.microsoft.ico": [".ico", "image/x-icon"],
    "com.microsoft.word.doc": [".doc", "application/msword"],
    "com.microsoft.excel.xls": [".xls", "application/vnd.ms-excel"],
    "com.microsoft.powerpoint.ppt": [".ppt", "application/vnd.ms-powerpoint"],
    "org.openxmlformats.spreadsheetml.sheet": [".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
    "org.openxmlformats.presentationml.presentation": [".pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
    "org.openxmlformats.wordprocessingml.document": [".docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
    "com.microsoft.waveform-audio": [".wav", "audio/wav"],
    "com.microsoft.advanced-systems-format": [".asf", "video/x-ms-asf"],
    "com.microsoft.windows-media-wm": [".wm", "video/x-ms-wm"],
    "com.microsoft.windows-media-wmv": [".wmv", "video/x-ms-wmv"],
    "com.microsoft.windows-media-wmp": [".wmp", "video/x-ms-wmp"],
    "com.microsoft.windows-media-wma": [".wma", "audio/x-ms-wma"],
    "com.microsoft.advanced-stream-redirector": [".asx", "video/x-ms-asx"],
    "com.microsoft.windows-media-wmx": [".wmx", "video/x-ms-wmx"],
    "com.microsoft.windows-media-wvx": [".wvx", "video/x-ms-wvx"],
    "com.microsoft.windows-media-wax": [".wax", "audio/x-ms-wax"],
    "com.apple.iwork.pages.sffpages": [".pages", "application/x-iwork-pages-sffpages"],
    "com.apple.iwork.numbers.sffnumbers": [".numbers", "application/x-iwork-numbers-sffnumbers"],
    "com.apple.iwork.keynote.sffkey": [".key", "application/x-iwork-keynote-sffkey"],
    "com.truevision.tga-image": [".tga", "image/x-tga"],
    "com.sgi.sgi-image": [".sgi", "image/sgi"],
    "com.sgi.rgb-image": [".rgb", "image/x-rgb"],
    "com.ilm.openexr-image": [".exr", "image/x-exr"],
    "com.kodak.flashpix.image": [".fpx", ".fpix", "image/vnd.fpx"],
    "com.j2.jfx-fax": [".jfx", "image/jfax"],
    "com.js.efx-fax": [".efx", "image/efax"],
    "com.digidesign.sd2-audio": [".sd2", "audio/x-sd2"],
    "com.real.realmedia": [".rm", "application/vnd.rn-realmedia"],
    "com.real.realmedia-vbr": [".rv", ".rmvb", "application/vnd.rn-realmedia-vbr"],
    "com.real.realaudio": [".ra", "audio/vnd.rn-realaudio"],
    "com.real.smil": [".smil", "application/smil"],
    "com.allume.stuffit-archive": [".sit", "application/x-stuffit"],
    "org.opml.opml": [".opml", "text/x-opml"],
    "net.daringfireball.markdown": [".md", "text/markdown"],
    "vnd.sqlite3": [".sqlite3", ".sqlite", ".db", "application/x-sqlite3"],
    "public.iso-image": [".iso", "application/x-iso-image"],
    "com.apple.disk-image": [".dmg", ".smi", ".img", "application/x-apple-diskimage"],
    "public.heic": [".heic", ".heif", "image/heic"],
    "com.apple.installer-package-archive": [".pkg", "application/x-apple-installer-package"],
    "public.mpeg-2-transport-stream": [".ts", "video/mp2t", "application/typescript", "text/typescript"],
    "public.x509-certificate": [".cer", ".crt", ".der", ".pem", "application/x-x509-ca-cert"],
    "com.microsoft.cab-archive": [".cab", "application/vnd.ms-cab-compressed"],
    "public.xz-archive": [".xz", "application/x-xz"],
    "public.7z-archive": [".7z", "application/x-7z-compressed"],
    "com.rarlab.rar-archive": [".rar", "application/x-rar-compressed"],
    "public.rpm-archive": [".rpm", "application/x-rpm"],
    "public.deb-archive": [".deb", "application/vnd.debian.binary-package"],
    "public.ar-archive": [".ar", "application/x-unix-archive"],
    "public.wasm-executable": [".wasm", "application/wasm"],
    "public.svg-image": [".svg", "image/svg+xml"],
    "public.webp": [".webp", "image/webp"],
    "public.avif": [".avif", "image/avif"],
    "public.pkcs8": [".p8", ".pkcs8", "application/pkcs8"],
    "public.pkcs10": [".p10", ".pkcs10", "application/pkcs10"],
    "public.x-pkcs12": [".p12", ".pfx", "application/x-pkcs12"],
    "public.systemd-swap-unit": [".swap", "application/systemd-swap"],
    "public.systemd-service-unit": [".service", "application/systemd-service"],
    "public.systemd-socket-unit": [".socket", "application/systemd-socket"],
    "public.webmanifest": [".webmanifest", "application/manifest+json"],
    "com.apple.xcode.project": [".xcodeproj", "application/x-xcodeproj"],
};
//# sourceMappingURL=constants.js.map